import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function ActionCentre({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="actions"
      eyebrow="MatrixOS recommendations"
      title="Action Centre"
      description="The highest-value leadership work recommended by MatrixOS."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
